import { z } from 'zod';
import { notePathSchema } from './note.js';
export const ingestUrlSchema = z.object({ url: z.string().url().max(2000) });
export const ingestCommitSchema = z.object({
    /** Result id from the extraction step (kept server-side for 30 minutes). */
    resultId: z.string().min(1),
    /** The (possibly edited) body markdown. */
    markdown: z.string().max(2_000_000),
    title: z.string().min(1).max(300),
    path: notePathSchema.optional(),
    type: z.string().min(1).max(64).default('reference'),
    tags: z.array(z.string().max(60)).max(20).default([]),
});
export const speakSchema = z.object({ text: z.string().min(1).max(2000), voice: z.string().max(80).optional() });
//# sourceMappingURL=ingest.js.map